import { render, staticRenderFns } from "./PartyForm.vue?vue&type=template&id=abd3637c&scoped=true"
import script from "./PartyForm.vue?vue&type=script&lang=js"
export * from "./PartyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd3637c",
  null
  
)

export default component.exports